import React, { useState, useEffect } from "react";
// import CreateGroup from '../CreateGroup/CreateGroup';
// import './UserSidebar.css';
import { CiSearch } from "react-icons/ci";
import chatpannelstyle from "../../style/components/bars/DmsPannel.module.css";
import barpannel from "../../style/components/bars/Bars.module.css";
import SidePannelShimmer from "../ui/Loader/Shimmer/SidePannelShimmer";
import FallbackAvatar from "../ui/FallbackAvatar/FallbackAvatar";
import WebSocketOnline from "../../services/onlineSocketService";
import { getSelectedDms, getUserToken } from "../../utils/auth";
import MainStyle from "../../style/Main.module.css";
import { renderQuillDelta } from "../../utils/textHelper";

const DmsPannel = ({
  directMessages: initialDirectMessages,
  loading,
  onSelectedConversation,
  searchTerm,
  setSearchTerm,
}) => {
  // const [searchTerm, setSearchTerm] = useState("");
  const selected = getSelectedDms();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [imgError, setImgError] = useState({});
  const [directMessages, setDirectMessages] = useState(initialDirectMessages); // local state

  useEffect(() => {
    setDirectMessages(initialDirectMessages); // update local state if prop changes
  }, [initialDirectMessages]);

  useEffect(() => {
    const token = getUserToken();

    if (token) {
      WebSocketOnline.connect(token);
    }

    WebSocketOnline.callbacks.onmessage = (data) => {
      if (data && data.type === "online_status") {
        const updatedStatuses = data.online_status;

        updatedStatuses.forEach((status) => {});

        // Update the online status in local state
        setDirectMessages((prevMessages) =>
          prevMessages.map((user) => {
            const updatedUser = updatedStatuses.find(
              (status) => status.id === user.user_id
            );
            if (updatedUser) {
              return { ...user, online_status: updatedUser.online_status };
            }
            return user;
          })
        );
      }
    };

    return () => {
      WebSocketOnline.disconnect();
    };
  }, []);

  const onSelectedPeople = (data) => {
    onSelectedConversation({
      data,
    });
  };
  const handleImgError = (id) => {
    setImgError((prev) => ({ ...prev, [id]: true }));
  };
  return (
    <div className={barpannel.BarsContainer}>
      <div className={barpannel.BarsContainerChild}>
        <div className={chatpannelstyle.DmsPannelHeader}>
          <h3>Direct Messages</h3>
        </div>

        <div className={chatpannelstyle.DmsPannelSearch}>
          <div className={chatpannelstyle.DmsPannelSearchInput}>
            <CiSearch className={chatpannelstyle.DmsPannelSearchInputsub} />
            <input
              placeholder="Search messages..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              aria-label="Search messages"
            />
          </div>
        </div>

        <div className={chatpannelstyle.DmsPannelListview}>
          {loading ? (
            Array(9)
              .fill()
              .map((_, i) => (
                <div key={`channel-shimmer-${i}`} style={{ margin: "8px 0" }}>
                  <SidePannelShimmer width="200px" height="35px" />
                </div>
              ))
          ) : directMessages.length > 0 ? (
            directMessages.map((dms) => {
              const messageFound = dms.leatest_message?.[0] || {};
              const message =
                messageFound.sending_messages?.[0] ||
                messageFound.receiving_messages?.[0] ||
                null;

              // const message = sending || reciving;
              return (
                <div
                  key={dms.private_chat_id}
                  onClick={() => onSelectedPeople(dms)}
                  // className={chatpannelstyle.DmsItemView}
                  className={`${chatpannelstyle.DmsItemView} ${
                    selected?.private_chat_id === dms?.private_chat_id
                      ? chatpannelstyle.DmsItemViewActive
                      : ""
                  }`}
                >
                  {/* <p>
                    {dms?.group_id}
                    {selected?.data?.data?.group_id}
                  </p> */}

                  <div className={MainStyle.ImageWrapper}>
                    {!imgError[dms.private_chat_id] ? (
                      <img
                        src={`${apiUrl}${dms.emp_pic}`}
                        alt={dms.name}
                        onError={() => handleImgError(dms.private_chat_id)}
                      />
                    ) : (
                      <FallbackAvatar name={dms.name} size={30} />
                    )}
                    {dms.is_group_chat === "0" && (
                      <span
                        className={
                          dms.online
                            ? MainStyle.OnlineIndicator
                            : MainStyle.OfflineIndicator
                        }
                      ></span>
                    )}
                  </div>
                  <div className={chatpannelstyle.dmspannelcontent}>
                    <p className={chatpannelstyle.DmsItemViewParaNme}>
                      {dms.name}
                    </p>
                    {message && (
                      <p className={chatpannelstyle.DmsItemViewParaMsg}>
                        {renderQuillDelta(message.message)}
                      </p>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <p className={chatpannelstyle.noDmsFound}>No DMs found</p>
          )}
        </div>

        {/* 
                <CreateGroup
                    show={iscreategroupviewopen}
                    onclose={() => setcreategroupviewopen(false)}
                /> */}
      </div>
    </div>
  );
};

export default DmsPannel;
